(function(){'use strict';
var rules=[
 [/\brefil+l?s?\b/gi,function(m){return /s$/i.test(m)?'refills':'refill'}],
 [/\breff?ills?\b/gi,function(m){return /s$/i.test(m)?'refills':'refill'}],
 [/\bballpen\b/gi,'ball pen'],
 [/\bball\s*point\b/gi,'ball pen'],
 [/\broler\b/gi,'roller'],
 [/\broller\s*ball(?:\s+pen)?\b/gi,'roller'],
 [/\brollerball(?:\s+pen)?\b/gi,'roller'],
 [/\bopen\s*cap(?:ped)?(?:\s+pen)?\b/gi,'openable pen'],
 [/\bcap\s+pen\b/gi,'openable pen'],
 [/\bcapped\s+pen\b/gi,'openable pen'],
 [/\bpen\s+with\s+(?:a\s+)?cap\b/gi,'openable pen'],
 [/\bcap\s+wala\s+pen\b/gi,'openable pen'],
 [/\bopenable\s+cap\b/gi,'openable pen'],
 [/\bclicker(?:\s+pen)?\b/gi,'click pen'],
 [/\bpush\s*button(?:\s+pen)?\b/gi,'click pen'],
 [/\bpush\s+pen\b/gi,'click pen'],
 [/\bpress\s+pen\b/gi,'click pen'],
 [/\bbutton\s+pen\b/gi,'click pen'],
 [/\brotate(?:\s+pen)?\b/gi,'twist pen'],
 [/\brotating\s+pen\b/gi,'twist pen'],
 [/\bghumane\s+wala\s+pen\b/gi,'twist pen'],
 [/\btwist\s+mechanism\s+pen\b/gi,'twist pen'],
 [/\bclick\s+mechanism\s+pen\b/gi,'click pen'],
 [/\bopenable\s+mechanism\s+pen\b/gi,'openable pen'],
 [/\bjoter\b/gi,'jotter'],
 [/\bcross\s+(?:compatible\s+|type\s+)?refill\b/gi,'cross type refill'],
 [/\bcross\s+refils?\b/gi,'cross type refill'],
 [/\bmetal\s+jotter(?!\s+refill)\b/gi,'metal jotter refill'],
 [/\bplastic\s+jotter(?!\s+refill)\b/gi,'plastic jotter refill'],
 [/\bmini\s+vt(?!\s+refill)\b/gi,'mini vt refill'],
 [/\bblue\s+refill\b/gi,'blue ink refill'],
 [/\bblack\s+refill\b/gi,'black ink refill'],
 [/\bred\s+refill\b/gi,'red ink refill'],
 [/\bgolden\s+clip\b/gi,'gold clip'],
 [/\bgoldclip\b/gi,'gold clip'],
 [/\bsilverclip\b/gi,'silver clip'],
 [/\bblueink\b/gi,'blue ink'],
 [/\bblackink\b/gi,'black ink'],
 [/\bredink\b/gi,'red ink'],
 [/\bmobile\s+touch(?:\s+pen)?\b/gi,'stylus pen'],
 [/\btouch\s+screen\s+pen\b/gi,'stylus pen'],
 [/\btouch\s+pen\b/gi,'stylus pen'],
 [/\bstylus\s+ballpoint\b/gi,'stylus ball pen'],
 [/\bdoctor(?:'s)?\s+(?:gift\s+)?pen\b/gi,'doctor pen'],
 [/\bdoctor\s+gift\b/gi,'doctor pen'],
 [/\blawyer\s+(?:gift\s+)?pen\b/gi,'advocate pen'],
 [/\badvocate\s+gift\b/gi,'advocate pen'],
 [/\bcompany\s+gift\s+pen\b/gi,'corporate gift pen'],
 [/\boffice\s+gift\s+pen\b/gi,'corporate gift pen'],
 [/\bname\s+(?:engraved\s+)?pen\b/gi,'engraved pen'],
 [/\bengraving\s+pen\b/gi,'engraved pen'],
 [/\bpersonalized\s+pen\b/gi,'personalised pen'],
 [/\bpersonalised\s+pen\b/gi,'personalised pen'],
 [/\bcustom\s+name\s+pen\b/gi,'engraved pen'],
 [/\bname\s+print(?:ed)?\s+pen\b/gi,'engraved pen'],
 [/\bname\s+writing\s+pen\b/gi,'engraved pen'],
 [/\bdhakkan\s+wala\s+pen\b/gi,'openable pen'],
 [/\bcap\s+vali?\s+pen\b/gi,'openable pen'],
 [/\bghuma(?:ne)?\s+wala\s+pen\b/gi,'twist pen'],
 [/\bpress\s+button\s+pen\b/gi,'click pen'],
 [/\broll?ar\s+pen\b/gi,'roller pen'],
 [/\bmetal\s+jotter\s+refils?\b/gi,'metal jotter refill'],
 [/\bplastic\s+jotter\s+refils?\b/gi,'plastic jotter refill'],
 [/\bjumbo\s+jotter(?:\s+refil+l?)?\b/gi,'jumbo jotter refill'],
 [/\bmini\s+vt\s+refils?\b/gi,'mini vt refill'],
 [/\bschmidt\s*888\s*f(?:\s+refill)?\b/gi,'schmidt 888 f refill'],
 [/\broller\s+refils?\b/gi,'roller refill'],
 [/\bcross\s+compatible(?:\s+refill)?\b/gi,'cross type refill'],
 [/\bcross\s+type(?!\s+refill)\b/gi,'cross type refill'],
 [/\bblue\s+colour\s+ink\b/gi,'blue ink'],
 [/\bblack\s+colour\s+ink\b/gi,'black ink'],
 [/\bred\s+colour\s+ink\b/gi,'red ink'],
 [/\bdr\.?\s+(?:gift\s+)?pen\b/gi,'doctor pen'],
 [/\bdoctor\s+gift\s+pen\b/gi,'doctor pen'],
 [/\bvakil\s+pen\b/gi,'advocate pen'],
 [/\blawyer\s+pen\b/gi,'advocate pen'],
 [/\badvocate\s+logo\s+pen\b/gi,'advocate pen'],
 [/\bcompany\s+logo\s+pen\b/gi,'corporate gift pen'],
 [/\bcorporate\s+logo\s+pen\b/gi,'corporate gift pen'],
 [/\boffice\s+gifting\b/gi,'corporate gifting'],
 [/\bbulk\s+pens?\b/gi,'corporate gift pen'],
 [/\bexam\s+gift\s+pen\b/gi,'exam pen'],
 [/\bstudent\s+gift\s+pen\b/gi,'exam pen'],
 [/\bschool\s+gift\s+pen\b/gi,'exam pen'],
 [/\brose\s*goldclip\b/gi,'rose gold clip'],
 [/\bcopperclip\b/gi,'copper clip']
]
function normalize(value){
 var q=String(value||'').trim();
 rules.forEach(function(rule){q=q.replace(rule[0],rule[1])});
 q=q.replace(/[|]+/g,' ').replace(/\s{2,}/g,' ').trim();
 return q;
}
function same(a,b){return String(a||'').trim().toLowerCase()===String(b||'').trim().toLowerCase()}
function prepareSearchForm(form,input){
 var original=String(input.value||'').trim();
 var normalized=normalize(original);
 if(!normalized||same(original,normalized))return;
 form.querySelectorAll('[data-bpb-search-intent-hidden]').forEach(function(node){node.remove()});
 input.removeAttribute('name');
 var q=document.createElement('input');
 q.type='hidden';q.name='q';q.value=normalized;q.setAttribute('data-bpb-search-intent-hidden','true');
 var originalField=document.createElement('input');
 originalField.type='hidden';originalField.name='bpb_original_q';originalField.value=original;originalField.setAttribute('data-bpb-search-intent-hidden','true');
 form.appendChild(q);form.appendChild(originalField);
}
function restoreOriginalQuery(){
 if(!window.URLSearchParams)return;
 var params=new URLSearchParams(window.location.search);
 var original=params.get('bpb_original_q');
 if(!original)return;
 document.querySelectorAll('form[action*="/search"] input[type="search"]').forEach(function(input){input.value=original});
 var heading=document.querySelector('.bpb-search-hero h1');
 if(heading&&/search results for/i.test(heading.textContent||''))heading.textContent='Search results for “'+original+'”';
 var summary=document.querySelector('.bpb-search-toolbar__summary span');
 if(summary)summary.textContent='for “'+original+'”';
}
document.addEventListener('submit',function(event){
 var form=event.target;
 if(!form||!form.querySelector)return;
 var action=(form.getAttribute('action')||'').toLowerCase();
 if(action.indexOf('/search')===-1)return;
 var input=form.querySelector('input[type="search"][name="q"]');
 if(!input)return;
 prepareSearchForm(form,input);
},true);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',restoreOriginalQuery);else restoreOriginalQuery();
window.BPBSearchIntent={normalize:normalize};
})();